import GaEvent from './GaEvent';

export default class CommentAddedGaEvent extends GaEvent {
  constructor() {
    super('comment_added');
  }
}
